import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useUnread(enabled) {
  const [unread, setUnread] = useState({});
  const refresh = useCallback(() => api.get("/messages-unread").then((r) => setUnread(r.data)).catch(() => {}), []);
  useEffect(() => {
    if (!enabled) { return undefined; }
    refresh();
    const t = setInterval(refresh, 10000);
    return () => clearInterval(t);
  }, [enabled, refresh]);
  return [unread, refresh];
}
